import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useUpdateFirmware } from './useUpdateFirmware';
import useUpdateFirmwareVersionColumns from './updateFirrmwareVersionColumn';
import './updateFirmwareVersion.scss';
import TableView from '../../tableView';

interface IProps {
  show?: boolean;
}

const UpdateFirmwareVersion = (props: IProps) => {
  const { row, handleClose, handleUpdate, onRowSelectionChange, isDisabled } =
    useUpdateFirmware();

  const { columns } = useUpdateFirmwareVersionColumns({ onRowSelectionChange });

  return (
    <>
      <Modal
        show={props.show}
        onHide={handleClose}
        className='modal-container modal'
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Firmware Version</Modal.Title>
        </Modal.Header>

        <Modal.Body className='modal-content-height'>
          <div className='firmware_container'>
            <div className='firmware_body'>
              <div className='table_content'>
                <div className={'manage-firmware-table '}>
                  <TableView
                    singleRowSelection={true}
                    data={row.values}
                    columns={columns}
                    noDataMessage={'No Data'}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button className='btn-cancel' onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className='btn-style'
            onClick={handleUpdate}
            disabled={isDisabled}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateFirmwareVersion;
